import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=dabcfd98&scoped=true&"
import script from "./Master.vue?vue&type=script&lang=js&"
export * from "./Master.vue?vue&type=script&lang=js&"
import style0 from "./Master.vue?vue&type=style&index=0&id=dabcfd98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabcfd98",
  null
  
)

export default component.exports